"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HoverTooltip = exports.Tooltip = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Popover_1 = require("../../components/Popover");
var Tooltip = function (props) {
  return (0, jsx_runtime_1.jsx)(Popover_1.Popover, __assign({
    tooltip: true,
    arrow: false,
    interactive: false
  }, props));
};
exports.Tooltip = Tooltip;
var HoverTooltip = function (props) {
  return (0, jsx_runtime_1.jsx)(Popover_1.HoverPopover, __assign({
    tooltip: true,
    arrow: false,
    interactive: false
  }, props));
};
exports.HoverTooltip = HoverTooltip;